var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 12,
    fill: "#EDF0F4",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 9L15.8896 9.31905V18.5763L15.9989 18.67L20.9973 16.13L15.9989 9Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9983 9L10.9998 16.13L15.9983 18.67V14.1768V9Z",
    fill: "#8C8C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9983 19.483L15.9368 19.5476V22.8451L15.9983 22.9997L20.9998 16.9443L15.9983 19.483Z",
    fill: "#3C3C3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9983 22.9997V19.483L10.9998 16.9443L15.9983 22.9997Z",
    fill: "#8C8C8C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 18.67L20.9977 16.13L15.9993 14.1768V18.67Z",
    fill: "#141414"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 16.13L15.9983 18.67V14.1768L10.9998 16.13Z",
    fill: "#393939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.298c5df7519ec8db36e1984da1363d02.svg";
export { ForwardRef as ReactComponent };